// Amateur Topic 12 — Order Block. Notes + infographics (scenes in scenes/advanced.jsx).
export default {
  title: 'Order Block',
  summary: 'The last candle before a big move — where big orders were placed.',
  subtopics: [
    { title: 'What It Is', scene: 'obWhat', cards: [
      { icon: '🏦', title: 'Where big orders sit', body: 'An Order Block (OB) is the area where banks placed big orders before a strong move.' },
      { icon: '🕯️', title: 'The last opposite candle', body: 'Bullish OB = the last red candle before a big rise. Bearish OB = the last green candle before a big drop.' },
      { icon: '💥', title: 'Needs a strong move', body: 'The move after it should be fast and break structure (BOS).' },
      { icon: '🧲', title: 'Price comes back', body: 'Price often returns to the OB later, and reacts there again.' },
    ] },
    { title: 'How to Find It', scene: 'obFind', cards: [
      { icon: '1️⃣', title: 'Find the big move', body: 'Spot a strong move that breaks a high or low.' },
      { icon: '2️⃣', title: 'Go to its start', body: 'Look where the move began.' },
      { icon: '3️⃣', title: 'Mark the last opposite candle', body: 'Draw a box from its high to its low.' },
      { icon: '🔭', title: 'Use H1–H4', body: 'OBs on bigger timeframes are more reliable.' },
    ] },
    { title: 'Using It for Entry', scene: 'obEntry', cards: [
      { icon: '⏳', title: 'Wait for the return', body: 'Let price come back into the OB box.' },
      { icon: '🕯️', title: 'Confirm by close', body: 'Wait for a candle in your direction to close.' },
      { icon: '🛑', title: 'Stop beyond the OB', body: 'Bullish OB: stop below the box. Bearish: above it.' },
      { icon: '🟡', title: 'Gold example', body: 'Bullish OB at 2,354–2,376. Gold returns to 2,365, a green candle closes, buy with a stop at 2,345.' },
    ] },
    { title: 'How It Differs From FVG', scene: 'obVsFvg', cards: [
      { icon: '🕯️', title: 'OB is a candle', body: 'An order block is one candle: the last opposite candle before the move.' },
      { icon: '🕳️', title: 'FVG is a gap', body: 'A fair value gap is the empty space between candle 1 and candle 3.' },
      { icon: '🤝', title: 'Often together', body: 'A strong move often makes both. An OB with an FVG right next to it is a stronger zone.' },
      { icon: '✅', title: 'Simple rule', body: 'Zone + trend direction + candle close + stop loss. Missing one? Wait.' },
    ] },
  ],
};
